import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-leo-batch",
  "use": "icon-leo-batch-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-leo-batch\">\r\n<g transform=\"translate(-113.571 -74.473) scale(1.221818)\">\r\n<path d=\"M160 224h288v576H160V224zm416-64h288v640H576V160zM224 320h160v64H224v-64zm416 0h160v64H640v-64z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/leo-batch.svg
// module id = ihQj
// module chunks = 409